import { useLocalSearchParams } from 'expo-router';
import { useMemo } from 'react';

type ParamValue = string | string[] | undefined;

function toSingleString(value: ParamValue): string {
  if (value == null) {
    return '';
  }

  return Array.isArray(value) ? (value[0] ?? '') : value;
}

/**
 * Search params normalized to single strings. useLocalSearchParams returns string | string[]
 * per key; this hook returns string ('' when missing) for each requested key.
 */
export function useSingleValueSearchParams<K extends string>(
  keys: readonly K[]
): Record<K, string> {
  const params = useLocalSearchParams() as Record<string, ParamValue>;

  return useMemo(() => {
    const result = {} as Record<K, string>;

    for (const key of keys) {
      result[key] = toSingleString(params[key]);
    }

    return result;
  }, [params, keys]);
}
